import packageJson from '../../package.json';

// config develop aplication
export const environment = {
    appVersion: packageJson.version + ' - dev',
    production: false,
    rowsPerPage: 10,
    applicationTimeout: 300000,
    incubaRest: 'S',
    trayIcon: 'N',
    noValidaWebsocket: 'S',

    // client system config
    clientSystem: {
        clientId: 'ba-web-presorte-core',
        clientSecret: 'ba-web-presorte-core'
    },

    // micro frontends routes
    microFrontends: {
        presorteo: 'https://dev-ml-presorteo.kodexasas.com/'
    },

    // micro services routes
    microServices: {
        origin: 'https://k8zynsbpr8.execute-api.us-east-1.amazonaws.com/dev/api/v1',
        authService: '/ms-presorteo-auth',
        coreService: '/ms-presorteo-core'
    }
};
